import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  Avatar,
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core'
import { KeyboardArrowRight } from '@material-ui/icons'
import PersonIcon from '@material-ui/icons/Person'
import SubmitterLog from 'assets/icons/GeneralLedger/submitter-log.svg'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { GreyTooltip } from 'containers/ARAPModule/Components/Tooltip/CustomTooltip'
import { useGetAssetDepreciableHistoryListingLazyQuery } from 'generated/graphql'
import { formatDate, formatTime } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'
import { AdvanceFilterHistoryDepreciation } from './Component/AdvanceFilterHistoryDepreciation'

const formatPeriod = (year: number, period: number) => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  return `${months[period - 1]}/${year}`
}

export const HistoryDepreciation = (props: any) => {
  let history = useHistory()
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))

  const [filteredList, setFilteredList] = useState([])
  const [TotalLength, setTotalLength] = useState(0)
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const curCompany = [{ Name: user?.companyName }]

  const [
    loadAssetDepreciableHistoryListing,
    { loading: getAssetDepreciableHistoryListingLoading },
  ] = useGetAssetDepreciableHistoryListingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getAssetDepreciableHistoryListing }) => {
      if (getAssetDepreciableHistoryListing?.Data?.length > 0) {
        setFilteredList(prevList => [
          ...prevList,
          ...getAssetDepreciableHistoryListing?.Data,
        ])
      }
      setTotalLength(getAssetDepreciableHistoryListing?.TotalLength)
    },
  })

  useEffect(() => {
    fetchDepreciationData({
      variables: {
        CompanyID: CompanyID,
        skip: 0,
        take: 30,
      },
    })
  }, [CompanyID])

  const setOriginalListing = (data: any) => {
    setFilteredList(data)
  }

  const fetchDepreciationData = ({ variables }: any) => {
    loadAssetDepreciableHistoryListing({
      variables: {
        CompanyID: variables.CompanyID,
        skip: variables.skip || 0,
        take: variables.take || 30,
        searchValue: variables.searchValue,
        sortField: variables.sortField,
        sortOrder: variables.sortOrder,
        AssetCardNo: variables.AssetCardNo,
        AssetName: variables.AssetName,
        Year: variables.Year,
        PeriodFrom: variables.PeriodFrom,
        PeriodTo: variables.PeriodTo,
      },
    })
  }

  return (
    <>
      {getAssetDepreciableHistoryListingLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/fixed-assets/${CompanyID}/depreciation`)
        }}
        smTitle="Fixed Assets"
        title={curCompany[0]?.Name}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Depreciation' },
          { name: 'History', current: true },
        ]}
      />

      <ContentWrapper footer>
        <List className="core-list">
          <AdvanceFilterHistoryDepreciation
            CompanyID={CompanyID}
            setOriginalListing={setOriginalListing}
            fetchData={fetchDepreciationData}
            documentType={['Posted', 'Pending']}
          />

          <List className="core-list">
            {filteredList === undefined || filteredList?.length === 0 ? (
              <EmptyList
                title="No Record found"
                subtitle="No depreciation history available."
              />
            ) : (
              <InfiniteScroll
                dataLength={filteredList?.length}
                next={() => {
                  const currentLength = filteredList?.length
                  fetchDepreciationData({
                    variables: {
                      CompanyID: CompanyID,
                      skip: currentLength,
                      take: 30,
                    },
                  })
                }}
                hasMore={filteredList?.length < TotalLength}
                className=""
                style={{ padding: '8px 6px' }}
                loader={
                  getAssetDepreciableHistoryListingLoading && (
                    <div style={{ textAlign: 'center' }}>
                      <CircularProgress />
                    </div>
                  )
                }
              >
                {filteredList?.map(el => {
                  const periodDisplay = formatPeriod(el?.year, el?.period)

                  return (
                    <ListItem key={el.fa_depreciation_ledger_id}>
                      <ListItemText
                        primary={
                          <>
                            <span className="desc date-width">
                              {formatDate(el?.transaction_date)}
                            </span>
                            <span className="flex-space mdLabel">
                              {el?.DocNo}
                            </span>
                            <span className="xsTitle c-orange">
                              {amtStr(el?.depreciation_amount)}
                            </span>
                          </>
                        }
                        secondary={
                          <>
                            <span className="desc" style={{ marginTop: '5px' }}>
                              {el?.Asset?.name}
                            </span>
                            <div
                              className="content-wrap full"
                              style={{ marginBottom: '-5px' }}
                            >
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={12}>
                                  <div className="icon-text">
                                    <GreyTooltip
                                      disableFocusListener
                                      title={
                                        <Fragment>
                                          <Grid
                                            container
                                            wrap="nowrap"
                                            spacing={2}
                                          >
                                            <Grid item>
                                              <Avatar
                                                style={{
                                                  width: '20px',
                                                  height: '20px',
                                                }}
                                              >
                                                <PersonIcon
                                                  style={{ fontSize: 'small' }}
                                                />
                                              </Avatar>
                                            </Grid>
                                            <Grid item xs zeroMinWidth>
                                              <div style={{ fontSize: '12px' }}>
                                                {el?.createdBy || 'System'}
                                              </div>
                                              <div style={{ fontSize: '10px' }}>
                                                {formatDate(el?.createdTs)}
                                                &nbsp;
                                                {formatTime(el?.createdTs)}
                                              </div>
                                            </Grid>
                                          </Grid>
                                        </Fragment>
                                      }
                                      arrow
                                      enterTouchDelay={0}
                                    >
                                      <img
                                        alt=""
                                        src={SubmitterLog}
                                        style={{
                                          width: '12px',
                                          marginRight: '3px',
                                        }}
                                      />
                                    </GreyTooltip>
                                    <span className="desc text-noflow">
                                      Depreciation Method:{' '}
                                      {el?.DepreciationMethod?.name}
                                    </span>
                                  </div>
                                </Grid>
                              </Grid>
                            </div>
                            <div
                              className="desc"
                              style={{ marginTop: '8px', fontSize: '12px' }}
                            >
                              <span>
                                Category: {el?.Asset?.Category?.name || 'N/A'}
                              </span>
                              <span style={{ margin: '0 8px' }}>•</span>
                              <span>Period: {periodDisplay}</span>
                              <span style={{ margin: '0 8px' }}>•</span>
                              <span>
                                Net Book Value:{' '}
                                {amtStr(el?.net_book_value_after_depreciation)}
                              </span>
                            </div>
                          </>
                        }
                      />
                      <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="view">
                          <KeyboardArrowRight
                            onClick={() => {
                              history.push({
                                pathname: `/fixed-assets/${CompanyID}/depreciation/history/${el?.fa_depreciation_ledger_id}`,
                                state: el,
                              })
                            }}
                          />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  )
                })}
              </InfiniteScroll>
            )}
          </List>
        </List>
      </ContentWrapper>

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
